import { useQuery } from '@tanstack/react-query';
import { vehicleRepository } from '../../repositories/vehicle-repository';

interface UseFetchModelsProps {
  brandCode: string;
}

export const useFetchModels = (props: UseFetchModelsProps) =>
  useQuery(
    ['vehicle-models', props],
    () => vehicleRepository.getVehicleModels(props.brandCode),
    {
      enabled: !!props.brandCode,
    },
  );
